module.exports = __webpack_public_path__ + "fonts/iconfont.b4171831.woff";